import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';
import $ from 'jquery';

domContentLoaded(() => {
	/* メインイメージのアニメーション用 */
	const $window = $(window);
	const $MvBottomItems = $('[class*="js_mv_bottom"]');

	const mvBottomAppear = () => {
		$MvBottomItems.each((i, item) => {
			if ($(item).offset().top < $window.height() + $window.scrollTop()) {
				$(item).addClass('is_appeared');
			}
		});
	};

	// if (sessionStorage.getItem('access')) {
	// 	$('body').addClass('js_notFirstAccess');
	// 	mvBottomAppear();
	// 	$window.on('scroll resize', throttle(100, () => {
	// 		mvBottomAppear();
	// 	}));
	// } else {
	// 	sessionStorage.setItem('access', true);
	// 	$('body').addClass('js_firstAccess');
	// 	$('.js_top_loadingObj').on('transitionend webkitTransitinEnd', () => {
	// 		$('.js_mv_txt').addClass('is_mv_start');
	// 	});
	// 	$('.js_mv_students_trigger').on('animationnend webkitAnimationEnd', () => {
	// 		$('.js_mv_students').addClass('is_mv_start');
	// 	});
	// 	$('.js_mv_sweets_trigger').on('animationnend webkitAnimationEnd', () => {
	// 		$('.js_mv_sweets').addClass('is_mv_start');
	// 	});
	// 	$('.js_mv_wrap_trigger').on('animationnend webkitAnimationEnd', () => {
	// 		setTimeout(() => {
	// 			$('.js_mv').addClass('is_mv_start');
	// 			$('.js_mv_header').addClass('is_mv_start');
	// 			$('.js_mv_bg').addClass('is_mv_start');
	// 		}, 300);
	// 	});
	// 	$('.js_mv_bg').on('animationnend webkitAnimationEnd', () => {
	// 		$('body').addClass('is_mv_end');
	// 		mvBottomAppear();
	// 		$window.on('scroll resize', throttle(100, () => {
	// 			mvBottomAppear();
	// 		}));
	// 	});
	// }

	/* インスタの埋め込み */
	// const returnInstaIndex = () => {
	// 	if (window.matchMedia('(max-width: 1023px)').matches) {
	// 		return 9;
	// 	}
	// 	return 18;
	// };
	// const instaIndex = returnInstaIndex(); // 1023ピクセル以下は9件、それ以外は18件表示します

	// $.ajax({ // jQueryのajaxでjsonデータを取得します
	// 	type: 'GET',
	// 	url: 'https://graph.facebook.com/v18.0/17841405664664861?access_token=key&fields=name,media{caption,like_count,media_url,thumbnail_url,permalink,timestamp,username}',
	// 	dataType: 'json',
	// 	success(json) {
	// 		const insta = json.media.data;
	// 		for (let i = 0; i < instaIndex; i++) {
	// 			const url = insta[i].thumbnail_url || insta[i].media_url; // 画像の時はそのままで、動画の時はサムネイルを表示します
	// 			const href = insta[i].permalink;

	// 			$('.js_insta_list').append(`
	// 				<li class="un_homeSnsInsta_item">
	// 					<a class="un_homeSnsInsta_link" href="${href}" target="_blank">
	// 						<div class="un_homeSnsInsta_img" style="background-image: url(${url});"></div>
	// 					</a>
	// 				</li>
	// 			`);
	// 		}
	// 	},
	// });
});
